/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useCallback, useLayoutEffect, useRef } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { iconEnum } from '~/modules/Helper/iconEnum';
import { TIPO_MENU_PORTAL } from '~/modules/Helper/tipoMenuPortal';
import { useMenus } from '~/contexts/menu.context';
import { useSelector } from 'react-redux';
import { getUrlDominio } from '~/modules/Helper/getUrl-helper';

import * as S from './Menu.styled';
import Icons from '../Icons/Icons.component';
import MenuPortalSearch from './MenuPortalSearch.component';

/**
 * Key estável e única por posição na árvore.
 * - Não usa Id da API (se repete entre irmãos, ex.: dois itens com Id 12).
 * - Não usa "/" (o Ant Design / rc-menu trata "/" como separador de path).
 */
function getMenuItemKey(_menu, parentKey = '', index = 0) {
  const segment = `m${index}`;
  return parentKey ? `${parentKey}__${segment}` : segment;
}

function normalizeSearchText(texto) {
  return String(texto || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Mantém a hierarquia do menu: inclui ancestrais do match e poda ramos sem resultado.
 */
function filterMenuTreeBySearch(items, searchTerm) {
  if (!items || items.length === 0) return [];

  return items.reduce((acc, item) => {
    const subItens = item.SubItens || [];
    const filteredChildren =
      subItens.length > 0 ? filterMenuTreeBySearch(subItens, searchTerm) : [];

    const selfMatches = normalizeSearchText(item.Titulo).includes(searchTerm);

    if (!selfMatches && filteredChildren.length === 0) {
      return acc;
    }

    const nextSubItens =
      filteredChildren.length > 0
        ? filteredChildren
        : selfMatches && subItens.length > 0
          ? subItens
          : [];

    acc.push({
      ...item,
      SubItens: nextSubItens,
    });

    return acc;
  }, []);
}

function findPathByKey(items, targetKey, parentKey = '', levels = []) {
  for (let index = 0; index < items.length; index += 1) {
    const item = items[index];
    const key = getMenuItemKey(item, parentKey, index);

    if (key === targetKey) {
      return [...levels, key];
    }

    if (item.SubItens && item.SubItens.length > 0) {
      const found = findPathByKey(item.SubItens, targetKey, key, [...levels, key]);
      if (found) return found;
    }
  }

  return null;
}

function findPathInSearchResult(searchItems, targetKey) {
  for (let index = 0; index < searchItems.length; index += 1) {
    const parentKey = `search-${index}`;
    const item = searchItems[index];
    const key = getMenuItemKey(item, parentKey, index);

    if (key === targetKey) {
      return [key];
    }

    if (item.SubItens && item.SubItens.length > 0) {
      const found = findPathByKey(item.SubItens, targetKey, key, [key]);
      if (found) return found;
    }
  }

  return null;
}

function Menu({ openKeys, setOpenKeys, setCollapsed, collapsed }) {
  const { menus, setMenuSelecionado } = useMenus();
  const { highContrast } = useSelector(state => state.configuration);
  const [searchResult, setSearchResult] = useState([]);
  const [isSearchInteractionLocked, setIsSearchInteractionLocked] = useState(false);
  const shouldUnlockAfterSearch = useRef(false);
  const history = useHistory();
  const isSearchActive = searchResult.length > 0;

  useLayoutEffect(() => {
    if (!shouldUnlockAfterSearch.current) {
      return;
    }

    shouldUnlockAfterSearch.current = false;
    setIsSearchInteractionLocked(false);
  }, [searchResult]);

  const handleSearchTermChange = useCallback(
    value => {
      setIsSearchInteractionLocked(true);
      setOpenKeys([]);

      const searchTerm = normalizeSearchText(value);
      const results = filterMenuTreeBySearch(menus, searchTerm);

      shouldUnlockAfterSearch.current = true;
      setSearchResult(results);
    },
    [menus, setOpenKeys]
  );

  const handleSearchClear = useCallback(() => {
    setIsSearchInteractionLocked(true);
    setOpenKeys([]);
    shouldUnlockAfterSearch.current = true;
    setSearchResult([]);
  }, [setOpenKeys]);

  function handleTitleClick(itemKey) {
    if (isSearchInteractionLocked) {
      return;
    }

    const menuLevels =
      searchResult.length > 0
        ? findPathInSearchResult(searchResult, itemKey)
        : findPathByKey(menus, itemKey);

    if (menuLevels) {
      if (openKeys.includes(itemKey)) {
        setOpenKeys(openKeys.filter(key => menuLevels.includes(key)));
      } else {
        const newOpenKeys = openKeys.filter(key => menuLevels.includes(key));
        setOpenKeys([...newOpenKeys, itemKey]);
      }
    } else {
      setOpenKeys([itemKey]);
    }
  }

  function formatUrl(url) {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `http://${url}`;
    }
    return url;
  }

  function handleRedirect(tipoMenuPortal, uri, subItens) {
    if (tipoMenuPortal === TIPO_MENU_PORTAL.EXTERNO) {
      // externo
      let newUri = '';
      if (subItens !== null) newUri = formatUrl(uri);
      else newUri = getUrlDominio() + uri;
      window.open(newUri);
    } else {
      history.replace(`/`);
      history.push(uri);
    }
    setOpenKeys([]);
  }

  function renderMenuItem(menu, parentKey = '', index = 0, searchMode = false) {
    const { Titulo, TipoMenuPortal, SubItens, Icone, URI } = menu;
    const itemKey = getMenuItemKey(menu, parentKey, index);
    const breadcrumbTitle = menu.Breadcrumb
      ? `⌂ / ${menu.Breadcrumb}`
      : Titulo;
    const disableHoverExpand = isSearchInteractionLocked;

    const handleSubMenuTitleClick = () => {
      if (URI) {
        handleRedirect(TipoMenuPortal, URI, SubItens);
        setMenuSelecionado(menu);
      }
    };

    const handleSubMenuTitleClick2 = () => {
      if (URI) {
        handleRedirect(TipoMenuPortal, URI, SubItens);
        setMenuSelecionado(menu);
      }
    };

    const handleMenuClick = () => {
      handleRedirect(TipoMenuPortal, URI, SubItens);
      setMenuSelecionado(menu);
      if (setCollapsed) setCollapsed(false);
    };

    const handleSubMenuIconClick = () => {
      handleTitleClick(itemKey);
    };

    if (SubItens && SubItens.length > 0) {
      return (
        <S.SubMenu
          key={itemKey}
          title={
            <div
              onMouseEnter={
                disableHoverExpand ? undefined : handleSubMenuIconClick
              }
              onClick={handleSubMenuTitleClick}
              title={breadcrumbTitle}
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                gap: 12,
                cursor: `${!menu.URI && 'default'}`,
              }}
            >
              {Icone && iconEnum.find(x => x.name === Icone)?.value()}
              <span style={{ flexGrow: 1, margin: 0 }}>{Titulo}</span>
              <span
                role="button"
                tabIndex={0}
                aria-label={`Expandir submenu ${Titulo || ''}`}
                onClick={event => {
                  event.stopPropagation();
                  handleSubMenuIconClick();
                }}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    event.stopPropagation();
                    handleSubMenuIconClick();
                  }
                }}
              >
                <Icons.ArrowRightOutlined />
              </span>
            </div>
          }
        >
          {SubItens.map((subItem, subIndex) =>
            renderMenuItem(subItem, itemKey, subIndex, searchMode)
          )}
        </S.SubMenu>
      );
    }

    // Tooltip NÃO pode envolver MenuItem (quebra <ul role="menu"> → list / aria-required-parent).
    return (
      <S.MenuItem
        key={itemKey}
        title={breadcrumbTitle}
        onMouseEnter={disableHoverExpand ? undefined : handleSubMenuIconClick}
        onClick={handleSubMenuTitleClick2}
        icon={Icone && iconEnum.find(x => x.name === Icone)?.value()}
        style={!collapsed ? { padding: '0px 20px' } : {}}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            event.preventDefault();
            handleMenuClick();
          }
        }}
      >
        <span title={breadcrumbTitle}>{Titulo}</span>
      </S.MenuItem>
    );
  }

  const handleMouseLeave = () => {
    if (isSearchInteractionLocked) {
      return;
    }

    setOpenKeys([]); // Fecha todos os submenus
  };

  return (
    <>
      <S.MenuStyles />
      <nav aria-label="Menu principal">
        {!collapsed ? (
          <MenuPortalSearch
            onSearchTermChange={handleSearchTermChange}
            onClear={handleSearchClear}
          />
        ) : null}
        <S.MenuScroll aria-label="Lista de itens do menu">
          <S.Menu
            theme={!highContrast ? 'dark' : 'light'}
            mode="vertical"
            inlineIndent={16}
            openKeys={openKeys}
            onMouseLeave={handleMouseLeave}
            aria-label="Itens do menu"
          >
            {menus && isSearchActive
              ? searchResult.map((item, index) =>
                  renderMenuItem(item, `search-${index}`, index, true)
                )
              : menus.map((item, index) => renderMenuItem(item, '', index, false))}
          </S.Menu>
        </S.MenuScroll>
      </nav>
    </>
  );
}

export default withRouter(Menu);
